import { useEffect, useState } from "react";
import { api } from "@/lib/api";

// Obras del Plan por Obra (todos los meses, las más recientes primero) para el combobox "Área / Obra".
let _frontsCache = { at: 0, list: [] };

export const useFrontOptions = () => {
  const [opts, setOpts] = useState(_frontsCache.list);
  useEffect(() => {
    const nowTs = Date.now();
    if (nowTs - _frontsCache.at < 60_000 && _frontsCache.list.length) { setOpts(_frontsCache.list); return; }
    api.get("/operations/front-plans").then((r) => {
      const seen = new Set(); const names = [];
      for (const p of r.data || []) {
        const n = (p.front_name || "").trim();
        if (n && !seen.has(n.toLowerCase())) { seen.add(n.toLowerCase()); names.push(n); }
      }
      _frontsCache = { at: nowTs, list: names };
      setOpts(names);
    }).catch(() => {});
  }, []);
  return opts;
};
